export default __webpack_public_path__ + "static/b9282b55af3d0973241358696defd98e.png";